import { NgModule } from '@angular/core';
import { DropZonePreviewComponent } from './drop-zone-preview/drop-zone-preview.component';
import { DropZoneLabelDirective } from '@nttp/drop-zone/src/lib/drop-zone-label.directive';
import { DropZoneRemoveBadgeComponent } from '@nttp/drop-zone/src/lib/drop-zone-preview/drop-zone-remove-badge/drop-zone-remove-badge.component';
import { DropZoneComponent } from '@nttp/drop-zone/src/lib/drop-zone/drop-zone.component';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
    DropZoneComponent,
    DropZonePreviewComponent,
    DropZoneLabelDirective,
    DropZoneRemoveBadgeComponent],
  imports: [
    CommonModule
  ],
  exports: [
    DropZoneComponent,
    DropZoneLabelDirective,
    DropZonePreviewComponent,
    DropZoneRemoveBadgeComponent]
})
export class DropZoneModule { }
